<template>
  <div class="header-logout">
    <!--<a target="_blank" href="http://popo.netease.com/static/html/open_popo.html?ssid=grp.zhitu@corp.netease.com&sstp=0" class="popo-tools">-->
    <!-- <img src="/img/popo.png"/>联系我们</a> -->
    <el-dropdown @command="onMenuClick" trigger="click">
      <div class="app-login-name">
        <el-avatar :size="32">
          <img src="/img/index/avatar.png" height="32"/>
        </el-avatar>
        &nbsp;&nbsp;{{ user.name }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </div>
      <el-dropdown-menu slot="dropdown" class="app-logout-dropdown g-dropdown">
        <el-dropdown-item command="mywork" :disabled="!getItemAuth('my-works')">我的作品</el-dropdown-item>
        <el-dropdown-item command="teamwork" v-if="getItemAuth('my-team')">团队作品</el-dropdown-item>
        <el-dropdown-item command="user" v-if="isAdmin" divided
          >成员管理</el-dropdown-item
        >
        <el-dropdown-item command="project" v-if="isProjectUser"
          >添加项目</el-dropdown-item
        >
        <el-dropdown-item command="admin" v-if="isSYSAdmin || isProjectAdmin"
          >后台管理</el-dropdown-item
        >
        <el-dropdown-item command="dataView" v-if="isAdmin"
          >数据统计</el-dropdown-item
        >
        <!--<el-dropdown-item command="fontFamily" v-if="isAdmin">字体库</el-dropdown-item>-->
        <el-dropdown-item command="logout">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <projects-dialog v-model="projectDialogVal"></projects-dialog>
  </div>
</template>
<script>
import projectsDialog from '@/views/project/projects-dialog'
import authService from '@/request/service/auth-service'
import { cp_hidden_routers } from '@/const.js'
import util from '@/util'
export default {
  components: { projectsDialog },
  data () {
    return {
      projectDialogVal: false,
      // selectedName: ''
    }
  },
  computed: {
    user () {
      return this.$store.state.app.loginUser
    },
    isProjectUser () {
      let isStudyCP = this.$store.getters['app/isStudyCP']
      return this.$store.getters['app/isProjectUser'] && !isStudyCP
    },
    isAdmin () {
      let isStudyCP = this.$store.getters['app/isStudyCP']
      return this.$store.getters['app/isAdmin'] && !isStudyCP
    },
    isProjectAdmin () {
      return this.$store.getters['app/isProjectAdmin']
    },
    isSYSAdmin () {
      return this.$store.getters['app/isSYSAdmin']
    }
  },
  // created () {
  //   this.selectedName = this.$route.name
  // },
  methods: {
    getItemAuth (itemName) {
      if (itemName === 'my-team') {
        return this.$store.getters['app/teamWorkVisible']
      }
      let isStudyCP = this.$store.getters['app/isStudyCP']
      if (isStudyCP) {
        return cp_hidden_routers.indexOf(itemName) > -1 ? false : true
      } else {
        return true
      }
    },
    exec () {
      return {
        mywork: () => {
          this.$router.push('/works/my')
        },
        teamwork: () => {
          this.$router.push('/works/team')
          // this.$router.push('/works/team')
        },
        logout: () => {
          authService
            .logout()
            .then(() => {
              let user = {
                email: '',
                id: '',
                mobile: '',
                name: '',
                projectApplyList: [],
                projectItems: [],
                role: '',
                projectRoles: []
              }
              this.$store.commit('app/set_login_user', user)
              let yktUrl = util.getYKTCache()
              if (yktUrl) {
                util.clearYKTCache()
                window.location.href = util.getYktUrl(yktUrl)
              } else {
                this.$router.push({ path: '/home' })
              }
            })
            .catch(err => {
              console.log(err)
            })
        },
        user: () => {
          let projects = this.$store.state.app.adminProjects
          if (projects.length > 1) {
            this.projectDialogVal = true
          } else if (projects.length == 1) {
            this.$router.push(
              `/admin/userManagement?projectId=${projects[0].id}`
            )
          }
        },
        project: () => {
          this.$router.push('/project/apply')
        },
        admin: () => {
          if (this.isProjectAdmin) {
            this.$router.push('/admin/tagsManage')
          } else {
            this.$router.push('/admin')
          }
        },
        dataView: () => {
          this.$router.push('/admin/dataView')
        },
        fontFamily: () => {
          this.$router.push('/admin/fontFamily')
        }
      }
    },
    onMenuClick (command) {
      let func = this.exec()[command]
      func()
    }
  }
}
</script>
<style lang="scss" scoped>
.header-logout{ // 2个地方用到
  display: flex;
  margin-left: 24px;
  flex-direction: row;
  align-items: center;
  .app-login-name {
    display: flex;
    align-items: center;
    color: #555C6A;
    // vertical-align: middle;
    // margin: 0px 8px;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>